import styled, { css } from "styled-components";
import { CircleOne, CircleThree, CircleTwo } from "../Spinner/style";
type ButtonProps = {
  secondary?: boolean
  color?: string
  disabled?:boolean
};

const ResponsiveButton = styled.button<ButtonProps>`
  display: inline-block;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  border: 2px solid transparent;
  padding: 0.75rem 3rem;
  font-size: 0.9rem;
  border-radius: 0.35rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
  border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: ${props => props.secondary? props.color: '#fff'} ;
  background-color: ${(props) => props.secondary ? '#fff' : props.color};
  border-color: ${(props) => props.color};
  opacity: ${props => props.disabled? '.5': '1' };
  outline: none;
 
  &:hover {
    ${props => !props.disabled?  css` 
      ${CircleOne}, ${CircleTwo}, ${CircleThree} {
          background-color: ${props.color};
      }
      background-color: ${props.secondary ? props.color : '#fff' };
      color: ${props.secondary ? '#fff' : props.color}` : ``}
  }


  @media print {
      height: 1px;
      visibility: hidden;
  }
`;
export { ResponsiveButton };
